module.exports = __webpack_public_path__ + "img/id-img-down.932c995c.png";